export default __webpack_public_path__ + "static/media/notification.a24f5222.svg";